import { useContext, useState, useEffect } from 'react';

import { FormParserContext } from 'src/contexts/form.context';
import { SecondaryButton } from 'src/components/Button';
import { ifTrue } from 'src/tools/logic.tools';
import { InputContext } from 'src/contexts/input.context';
import { InlineTextarea as Component } from 'src/components/InputRenderers';

import classes from 'src/components/FormRenderers/InlineTextareaButton/InlineTextareaButton.module.scss';

export function InlineTextareaButton() {
  const { script, onChange, value = '', error, resource_id, isDisabled } = useContext(FormParserContext);

  const [isOpen, setIsOpen] = useState(false);

  const [isActive, setIsActive] = useState(false);

  const [innerValue, setInnerValue] = useState(value);

  useEffect(() => {
    setInnerValue(value);
    setIsOpen(!!value);
    setIsActive(false);
  }, [value, resource_id]);

  function handleOnButtonClick() {
    setIsOpen(true);
    setIsActive(true);
  }

  function handleOnTextareaClick() {
    if (!isActive) setIsActive(true);
  }

  function handleOnTextareaSubmit() {
    setIsActive(false);

    if (innerValue !== value) onChange(innerValue);
  }

  function handleOnTextareaDiscard() {
    setIsActive(false);
    setInnerValue(value);
  }

  function renderTextarea() {
    return (
      <InputContext.Provider
        value={{
          classNames: { container: 'w-100p', input: ifTrue(error, 'with-error') },
          value: innerValue,
          onChange: setInnerValue,
          onClick: handleOnTextareaClick,
          onSubmit: handleOnTextareaSubmit,
          onDiscard: handleOnTextareaDiscard,
          isDisabled: script.isDisabled || isDisabled,
          isReadonly: !isActive,
          isAutoFocus: script.autofocus,
          placeholder: script.placeholder,
        }}
      >
        <Component />
      </InputContext.Provider>
    );
  }

  function renderButton() {
    return (
      <SecondaryButton
        classNames={{ container: classes.button }}
        onClick={handleOnButtonClick}
        label={script.buttonLabel}
        isDisabled={isDisabled}
      />
    );
  }

  return ifTrue(isOpen, renderTextarea, renderButton);
}
